export default "__VITE_ASSET__oA0DiQc1__"